import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

/** What is connected on the server (GET /capabilities). An action that depends on something off shows "Próximamente". */
export interface Capabilities {
  operationsWritable?: boolean;
  maps: {
    /** The day's route can be calculated with Google (server key and workshop address). */
    routes: boolean;
    /** The trip distance of a site can be calculated: with Google, or without a key from OpenStreetMap. */
    distances?: boolean;
    /** The map and the address autocomplete can load in the browser. */
    browserKey: string | null;
    mapId: string | null;
    regionCode: string | null;
    originAddress: string | null;
    originLatitude: string | null;
    originLongitude: string | null;
  };
  ai: boolean;
  whatsapp: boolean;
  meta: { ready: boolean; ads: boolean };
  mercadolibre: { ready: boolean; connected: boolean };
}

export const capabilitiesKey = ['capabilities'] as const;

export const capabilitiesQuery = () =>
  queryOptions({
    queryKey: capabilitiesKey,
    queryFn: ({ signal }) => api<Capabilities>('/capabilities', { signal }),
    staleTime: 5 * 60_000,
    refetchInterval: 30_000,
  });

/** While loading, everything counts as not connected: nothing turns on and then off again. */
export function useCapabilities(): Capabilities {
  const { data } = useQuery(capabilitiesQuery());
  return data ?? OFF;
}

const OFF: Capabilities = {
  maps: { routes: false, distances: false, browserKey: null, mapId: null, regionCode: null, originAddress: null, originLatitude: null, originLongitude: null },
  ai: false,
  whatsapp: false,
  meta: { ready: false, ads: false },
  mercadolibre: { ready: false, connected: false },
};
